import styles from './CarouselSelectedImageCategory.module.less';
import { useEffect, useRef } from 'react';

interface Resources {
  style: any;
  images: string[];
}

interface CarouselSelectedImageCategoryI {
  selectedGallery: Resources;
  onSelectImage: (srcImage: string) => void;
}

function CarouselSelectedImageCategory(props: CarouselSelectedImageCategoryI) {
  const scrollContainer = useRef(null);
  useEffect(() => {
    if (!scrollContainer.current) {
      return;
    }

    const elem = scrollContainer.current as HTMLElement;
    const scrollY2X = (evt: any) => {
      evt.preventDefault();
      elem.scrollLeft += evt.deltaY as number;
    };

    elem.addEventListener('wheel', scrollY2X);
    return () => {
      elem.removeEventListener('wheel', scrollY2X);
    };
  }, [scrollContainer]);

  return (
    <div
      ref={scrollContainer}
      className={`flex flex-nowrap gap-2.5 ${styles['carousel']} overflow-x-scroll disable-scrollbars`}
    >
      {props?.selectedGallery?.images?.map((item, index) => (
        <img
          style={props.selectedGallery.style}
          onClick={() => props.onSelectImage(item)}
          className="xl:w-1/12 lg:w-1/8 md:w-1/6 sm:w-1/4 w-1/3 cursor-pointer"
          src={item}
          alt={index.toString()}
          key={index}
        />
      ))}
    </div>
  );
}

export default CarouselSelectedImageCategory;
